if (typeof joining_settings !== 'undefined') {
	console.log('JoiningVars: ', joining_settings);
}

if (typeof joining_validation_fields_txt !== 'undefined') {
	console.log('Joining Fields Forms Settings', joining_validation_fields_txt);
}

const {
	waterGlobalId = [],
	dayPassGlobalId = [],
	studentGlobalId = [],
	lockerGlobalId = [],
	boxingGlobalId = [],
	boxingSpecialId = [],
	subOneFlexPrimeId = [],
	subOneId = [],
	subFlexId = [],
	subPrimeId = [],
	personalTrainingGlobalId = []
} = window.vgHelpersData?.global_ids ?? {};

class JoiningVars {
	static get_setting_field = (key, path='es-es', settings_type='global-settings', format = 'settings', modal_key = '') => {
		const all_settings = window.joining_settings ?? {};

		if (!all_settings[`/${path}/`] || !all_settings[`/${path}/`][settings_type]) {
			return undefined;
		}

		const settings = all_settings[`/${path}/`][settings_type];

		if (format === 'settings') {
			return settings.settings[key];
		}

		if (format === 'modal') {
			// allways modal_key is lowercase
			modal_key = modal_key.toLowerCase();

			const modal = settings.modals.find(modal => modal.modal_key === modal_key);
			return modal ? modal[key] : undefined;
		}

		return undefined;
	};

	static get_modal_setting_field = (modal_key, modal_field, path='es-es') => {
		return this.get_setting_field(modal_field, path, 'global-settings', 'modal', modal_key);
	};

	static get_form_field = (key) => {
		if (typeof joining_validation_fields_txt !== 'undefined') {
			return window.joining_validation_fields_txt[key];
		}
		return key;
	}
}
